import '.g{display:flex;}.ssr-plugin'
import '.k{justify-content:center;}.ssr-plugin'
import '.h{flex-direction:column;}.ssr-plugin'
import '.i{align-items:center;}.ssr-plugin'
import '.aj{gap:0.5rem;}.ssr-plugin'
import '.ap{cursor:pointer;}.ssr-plugin'
import '.d0{padding:0.75rem;}.ssr-plugin'
import '.ad{border-radius:1.25rem;}.ssr-plugin'
import '.ak{border:var(--blue-border);}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.cp{transition:background-color 0.2s ease;}.ssr-plugin'
import '.dy{width:2.5rem;}.ssr-plugin'
import '.dz{height:2.5rem;}.ssr-plugin'
import '.hh{color:var(--shades-blue-700);}.ssr-plugin'
import '.hi{font-size:0.9rem;}.ssr-plugin'
import '.b0{font-weight:400;}.ssr-plugin'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'inlines'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { MouseEventHandler } from 'react'

export type SocialMediaButtonProps = {
  icon: IconProp
  label: string
  onClick: MouseEventHandler<HTMLButtonElement>
  isMobile?: boolean
}

export const SocialMediaButton = ({
  icon,
  label,
  onClick,
  isMobile,
}: SocialMediaButtonProps) => {
    return (
      <styled.button className="g k h i aj ap d0 ad ak ae cp"
        style={{
          '&:hover': {
            backgroundColor: 'var(--shades-blue-50)',
          },
          width: isMobile ? '8rem' : '5.5rem',
          height: isMobile ? '8rem' : '5.5rem',
        }}
        onClick={onClick}
      >
        <div className="dy dz g i k hh"
          style={{
            fontSize: isMobile ? '3rem' : '2rem',
          }}
        >
          <FontAwesomeIcon icon={icon} />
        </div>
        <span className="hi hh b0"
        >
          {label}
        </span>
      </styled.button>
    )
}